import { createContext } from "react";

export const CartInfo = createContext()
export const CartItem = createContext()
export const ProductCategory = createContext()